import {Preference, PreferencesService} from "src/app/core/services/services/preferences.service";
import {isUndefined} from "lodash";
import {BannerTemplate, IBTemplateData} from "src/app/core/components/information-banner/information-banner-templates";

interface CookieBannerTemplateData extends IBTemplateData {
	onConsent: () => void;
	onNotConsent: () => void;
}

export class CookieBannerTemplate implements BannerTemplate {
	templateRef = "cookieBanner";
	templateData = <CookieBannerTemplateData>{
		onConsent: () => {
			this.preferenceService.put(Preference.USER_CONSENT_COOKIES, "true").then();
			// @ts-expect-error window.clarity might be available if microsoft clarity is started
			if (typeof window.clarity === "function") {
				// @ts-expect-error window.clarity is available now
				window.clarity("consent");
			}
		},
		onNotConsent: () => {
			this.preferenceService.put(Preference.USER_CONSENT_COOKIES, "false").then();
		},
	};
	shouldBeHidden = async () => {
		let consent = await this.preferenceService.get(Preference.USER_CONSENT_COOKIES);
		// @ts-expect-error window.clarity might be available if microsoft clarity is started
		if (consent === "true" && !isUndefined(window.clarity)) {
			// @ts-expect-error window.clarity is available now
			window.clarity("consent");
		}
		// @ts-expect-error window.clarity might be available if microsoft clarity is started, if not might as well not show this Banner
		return !isUndefined(consent) || isUndefined(window.clarity);
	};

	constructor(private readonly preferenceService: PreferencesService) {}
}
